<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('delete_campaign') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider
    div.px-6
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('campaign').toLowerCase() }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('campaign').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md(@click="deleteCampaign" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DeleteCampaignDialog',
  props: ['open', 'deleted', 'campaigns'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteCampaign() {
      this.isLoading = true
      const ids = this.campaigns.map(item => item.id).join(',')
      this.$axios.delete(`/donations/${this.company.slug}/campaigns/${ids}`)
      .then(() => {
        this.showMessage(['success', this.$t('success_message.campaign_deleted_successfully')])
        this.$emit('deleted')
        this.showDialog = false
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>